export const customerCenters: {name: string, value: string}[] = [
  {name: 'receiver', value: '01'},
  {name: 'payer', value: '02'},
  {name: 'taxer', value: '03'},
];